import AddressFormFields from "@repo/components/src/forms/address";
import { Text } from "@repo/components/src/ui/text";
import { VStack } from "@repo/components/src/ui/vstack";
import { ComponentProps } from "react";

import type { TaxProfileFormState } from "./useTaxProfileForm";
import type { TaxProfileFieldData } from "./types";

type Props = {
  field: TaxProfileFieldData;
  form: TaxProfileFormState;
  countryCode: string;
  size: ComponentProps<typeof AddressFormFields>["size"];
};

export default function AddressField({
  field,
  form,
  countryCode,
  size,
}: Props) {
  return (
    <VStack space="sm">
      <Text bold className="text-typography-950">
        {field.label}
      </Text>
      {field.helpText ? (
        <Text size="xs" className="text-typography-600">
          {field.helpText}
        </Text>
      ) : null}
      <AddressFormFields
        formProps={form.address.formProps}
        countryCode={countryCode}
        format={form.address.format}
        formatLoading={form.address.loading}
        size={size}
      />
    </VStack>
  );
}
